import type { VoidFunctionComponent } from 'react';

import ModalAddDependency from '../../../modals/ModalAddDependency/ModalAddDependency';

import type { ModalProps } from '.';

type Props = ModalProps & {
  onProjectChange: () => void;
};

const AddDependency: VoidFunctionComponent<Props> = ({ projectRevision, modals, onProjectChange }) => {
  const { isOpen, onClose } = modals.addDependencyModal;
  const { mode, dependencyToOverwrite } = modals.addDependencyModal.context;

  if (!mode) {
    return null;
  }

  return (
    <ModalAddDependency
      mode={mode}
      dependencyToOverwrite={dependencyToOverwrite}
      parentLocator={projectRevision}
      show={isOpen}
      onHide={onClose}
      onProjectChange={onProjectChange}
  />
  );
};

export default AddDependency;
